import { CommercialRoles, Prisma } from "@prisma/client";
import { Paginated, Sortable } from "./utils.types";

export const exhibitorCommercialMeetingTypeValues =
  Prisma.validator<Prisma.CommercialMeetingDefaultArgs>()({
    select: {
      id: true,
      beginningHour: true,
      date: true,
      endHour: true,
      email: true,
      firstName: true,
      lastName: true,
      personalComment: true,
      gender: true,
      commercial: true,
      target: {
        select: {
          picture: true,
        },
      },
    },
  });

export type ExhibitorCommercialMeetingType = Prisma.CommercialMeetingGetPayload<
  typeof exhibitorCommercialMeetingTypeValues
>;

export const exhibitorCommercialClientTypeValues =
  Prisma.validator<Prisma.CommercialClientDefaultArgs>()({
    select: {
      id: true,
      comment: true,
      targetUser: {
        select: {
          id: true,
          firstName: true,
          lastName: true,
          picture: true,
          dateOfBirth: true,
          phoneNumber: true,
          interest: true,
          zipCode: true,
          email: true,
          address: true,
        },
      },
      targetStructure: {
        select: {
          id: true,
          picture: true,
          businessName: true,
          businessEmail: true,
          admin: {
            select: {
              id: true,
              firstName: true,
              lastName: true,
              picture: true,
              dateOfBirth: true,
              phoneNumber: true,
              interest: true,
              zipCode: true,
              email: true,
              address: true,
            },
          },
        },
      },
      createdAt: true,
    },
  });

export type ExhibitorCommercialClientType = Prisma.CommercialClientGetPayload<
  typeof exhibitorCommercialClientTypeValues
>;

export type ExhibitorCommercialClientSecuredType = Omit<
  ExhibitorCommercialClientType,
  "targetUser.dateOfBirth" | "targetStructure.admin.dateOfBirth"
> & { ageGroup: string };

export const CommercialMeetingValues =
  Prisma.validator<Prisma.CommercialMeetingDefaultArgs>()({
    select: {
      id: true,
      date: true,
      beginningHour: true,
      endHour: true,
      gender: true,
      personalComment: true,
      firstName: true,
      lastName: true,
      email: true,
      targetId: true,
      target: {
        select: {
          id: true,
          firstName: true,
          lastName: true,
          email: true,
          picture: true,
        },
      },
    },
  });

export type CommercialMeeting = Prisma.CommercialMeetingGetPayload<
  typeof CommercialMeetingValues
>;

export const CommercialMeetingWithCommercialValues =
  Prisma.validator<Prisma.CommercialMeetingDefaultArgs>()({
    select: {
      id: true,
      date: true,
      beginningHour: true,
      endHour: true,
      gender: true,
      personalComment: true,
      firstName: true,
      lastName: true,
      email: true,
      targetId: true,
      target: {
        select: {
          id: true,
          firstName: true,
          lastName: true,
          email: true,
          picture: true,
        },
      },
    },
    include: {
      commercial: {
        include: {
          user: true,
        },
      },
      target: true,
    },
  });

export type CommercialMeetingWithCommercial =
  Prisma.CommercialMeetingGetPayload<
    typeof CommercialMeetingWithCommercialValues
  >;

export const commercialRoleRanks: Record<CommercialRoles, number> = {
  admin: 3,
  commercial: 2,
  guest: 1,
};

// eslint-disable-next-line @typescript-eslint/ban-types
type FilterClientType = {};

export type FilterClientTypeWithPaginationAndSorting = Sortable<
  Paginated<FilterClientType>
>;

export type CommercialEventAccessNotParticipating = {
  hasCommercialAppAccess: false;
  reason: "NOT_PARTICIPATING";
};

export type CommercialEventAccessMissingPack = {
  hasCommercialAppAccess: false;
  reason: "MISSING_PACK3";
};

export type CommercialEventAccessGranted = {
  hasCommercialAppAccess: true;
};

export type CommercialEventAccessResponse =
  | CommercialEventAccessNotParticipating
  | CommercialEventAccessMissingPack
  | CommercialEventAccessGranted;
